import { Link } from "react-router-dom";
import { ArrowRight, Building, Landmark, HeartPulse, Building2 } from "lucide-react";
import { useSeo } from "../components/site/Layout";
import { PageHero, Section, CheckList, ThirdPartyNotice, CtaBand } from "../components/site/blocks";
import { Reveal } from "../components/site/Reveal";
import { IMAGES } from "../data/site";

const SEGMENTS = [
  { id: "bailleurs", icon: Building, t: "Bailleurs sociaux", d: "Adapter les logements au vieillissement et au handicap.", items: ["Diagnostics de logements et de parc", "Cahiers des charges types", "Pilotage en site occupé"] },
  { id: "collectivites", icon: Landmark, t: "Collectivités", d: "Programmer, consulter, suivre vos opérations.", items: ["Études de programmation", "Assistance aux consultations", "Suivi et bilan"] },
  { id: "etablissements", icon: HeartPulse, t: "Établissements médico-sociaux", d: "EHPAD, résidences autonomie : accessibilité et sécurité.", items: ["Diagnostic accessibilité", "Phasage compatible exploitation", "Coordination des entreprises"] },
  { id: "coproprietes", icon: Building2, t: "Copropriétés & syndics", d: "Parties communes, rénovation, démarches individuelles.", items: ["Préparation des AG", "Aides collectives", "Suivi de chantier"] },
];

export default function Professionnels() {
  useSeo("Professionnels : bailleurs, collectivités, établissements, copropriétés", "Assistance à maîtrise d'ouvrage et maîtrise d'ouvrage déléguée pour l'adaptation, l'accessibilité et la rénovation : bailleurs sociaux, collectivités, EHPAD, copropriétés.");
  return (
    <>
      <PageHero eyebrow="Professionnels" title="Une AMO indépendante pour vos programmes" intro="Programmation, consultation, pilotage — ou maîtrise d'ouvrage déléguée."
        image={IMAGES.pros} imageAlt="Professionnels examinant des plans de bâtiment dans une salle de réunion vitrée">
        <Link to="/contact?profil=professionnel" className="btn-accent" data-testid="pros-quote-cta">Décrire mon projet <ArrowRight className="h-5 w-5" aria-hidden="true" /></Link>
        <Link to="/services/amo-maitrise-ouvrage-deleguee" className="btn-outline" data-testid="pros-amo-link">Notre offre AMO</Link>
      </PageHero>
      <Section eyebrow="Vos enjeux" title="Nous travaillons avec">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {SEGMENTS.map((s, i) => (
            <Reveal key={s.id} delay={i * 70}>
              <details className="group bento p-6 h-full open:bg-brand-50" data-testid={`pro-segment-${s.id}`}>
                <summary className="list-none cursor-pointer">
                  <span className="h-11 w-11 rounded-2xl bg-brand-100 text-brand-ink flex items-center justify-center"><s.icon className="h-5 w-5" aria-hidden="true" /></span>
                  <h3 className="mt-6 text-xl">{s.t}</h3>
                  <p className="mt-1 text-[15px] text-slate-600">{s.d} <span className="text-brand-ink font-semibold group-open:hidden">Détails</span></p>
                </summary>
                <div className="mt-4"><CheckList items={s.items} /></div>
              </details>
            </Reveal>
          ))}
        </div>
      </Section>
      <Section tone="dark" eyebrow="Notre posture" title="Ce que nous garantissons">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <CheckList dark items={["Indépendance totale : aucune exécution de travaux.", "Livrables écrits à chaque phase.", "Respect de vos règles d'achat.", "Un interlocuteur unique, reporting régulier."]} />
          <img src={IMAGES.worksite} alt="Coordinatrice de chantier et artisan dans un logement en travaux" loading="lazy" className="w-full aspect-[16/10] object-cover rounded-[28px]" />
        </div>
      </Section>
      <Section><ThirdPartyNotice /></Section>
      <CtaBand title="Un programme à lancer ?" text="Présentez-nous votre opération : proposition de méthode sous 48 h ouvrées." />
    </>
  );
}
